import React from 'react';
import { getHaiImageSrc } from '../haiUtils';

/**
 * 単一の牌を表示するコンポーネント
 * @param {object} props
 * @param {number} props.haiId - 表示する牌のID
 * @param {object} props.style - img要素に適用する追加のスタイル
 */
const Hai = ({ haiId, style }) => {
  const defaultStyle = { width: '100%', height: 'auto', display: 'block' };
  return (
    <img
      draggable={false}
      src={getHaiImageSrc(haiId)}
      alt={`hai-${haiId}`}
      style={{ ...defaultStyle, ...style }}
    />
  );
};

export default Hai;